var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHandCashRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.6415 12.75H20.3915L20.8625 13.542C21.0785 13.8663 21.0785 14.2887 20.8625 14.613L20.5625 15.06C20.3704 15.3482 20.3475 15.7173 20.5025 16.027L21.0025 17.027C21.1385 17.299 21.1385 17.6191 21.0025 17.891L20.4315 19.032C20.3173 19.2611 20.2986 19.5261 20.3795 19.769L20.5465 20.269C20.6628 20.6159 20.5725 20.9987 20.3135 21.257L18.8915 22.5H12.1215C11.7532 22.4999 11.3884 22.5702 11.0465 22.707L9.14648 23.25",
    stroke: "#E60000",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.39111 17.4572L5.63311 16.2412C6.03538 16.0894 6.37561 15.8079 6.60011 15.4412L8.68512 10.6192C8.90402 10.2633 9.19741 9.95895 9.54512 9.72719L10.2711 9.24219",
    stroke: "#E60000",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6934 12.205L9.14737 1.373C9.1244 1.21648 9.1707 1.05771 9.27421 0.93807C9.37771 0.818432 9.52817 0.749778 9.68637 0.750001H17.2384",
    stroke: "#E60000",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9099 12.7501L13.0639 4.34112C13.0488 4.1996 13.0947 4.05835 13.1902 3.95278C13.2856 3.84721 13.4215 3.78732 13.5639 3.78812H20.4639C20.611 3.78637 20.7514 3.84947 20.8477 3.96065C20.944 4.07182 20.9865 4.21977 20.9639 4.36512L19.7059 12.7501",
    stroke: "#E60000",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8359 8.62109C17.0425 8.62111 17.2102 8.78819 17.2109 8.99477C17.2116 9.20136 17.0452 9.36962 16.8386 9.37108C16.632 9.37255 16.4631 9.20667 16.4609 9.00009C16.4609 8.79299 16.6288 8.62509 16.8359 8.62509",
    stroke: "#E60000",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHandCashRed);
export default __webpack_public_path__ + "static/media/HandCashRed.f499fb55326f83420606f798fc0c864c.svg";
export { ForwardRef as ReactComponent };